import { School, CheckCircle2 } from "lucide-react";
import { education } from "@/data/profile";

export const Education = () => (
  <section className="section" id="education">
    <div className="container">
      <p className="eyebrow">03 · Education</p>
      <h2 className="section-title">Education</h2>
      <div className="education-card" data-testid="education-card-council-rock">
        <div className="education-icon">
          <School size={26} />
        </div>
        <div className="education-info">
          <h3 className="timeline-role">{education.school}</h3>
          <p className="timeline-company">{education.program} · {education.period}</p>
          <ul className="education-highlights">
            {education.highlights.map((h) => (
              <li key={h}>
                <CheckCircle2 size={15} /> {h}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
